import apiHelper, { ApiResponseType } from "./apiHelper";
import axios, { AxiosResponse } from "axios";
import { AUTH_TOKEN, FIRM_PATH, IS_DEMO } from "../../constants/storageKeys";
import appHelpers from "../../common/helpers/appHelpers";
import { isLogoAppProject } from "../helpers/globalHelpers";
import { publicRoutes } from "../../routes";

export const baseApiUrl = process.env.REACT_APP_BASE_URL;
const baseUrl = process.env.REACT_APP_BASE_URL + "/api/v1";
/**
 * 23.02.2026 Apisauce replacement
 */
const api = axios.create({
  baseURL: baseUrl,
  validateStatus: () => true, // hata fırlatmaz (apisauce gibi)
});

/**
 * Apisauce response.ok taklidi
 */
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return {
      ...response,
      ok: response.status >= 200 && response.status < 300,
    } as any;
  },
  (error) => {
    if (error.response) {
      return Promise.resolve({
        ...error.response,
        ok: false,
      });
    }

    return Promise.resolve({
      ok: false,
      status: 0,
      data: null,
    });
  }
);

const commonNetwork = {

  get: async function (method: string, params?: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    const response: any = await api.get(method, {
      params: params,
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck && method != "/token/checkToken") {
        const createResult = await this.createToken();
        if (createResult) {
          return this.get(method, params);
        }
      }
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },

  downloadFileGetRequest: async function (method: string, params?: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    const response: any = await api.get(method, {
      params: params,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck && method != "/token/checkToken") {
        const createResult = await this.createToken();
        if (createResult) {
          return this.get(method, params);
        }
      }
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },

  post: async function (method: string, obj: any, isDocumentDownload?: boolean): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    let extraProps: any = {};
    if (isDocumentDownload) {
      extraProps = { responseType: "blob" };
    }

    const response: any = await api.post(method, obj, {
      ...extraProps,
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json"
      }
    });

    if (isDocumentDownload) {
      return {
        data: response.data,
        isSuccess: true,
        errorMessage: ""
      };
    }

    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck) {
        const createResult = await this.createToken();
        if (createResult) {
          return this.post(method, obj);
        }
      }
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },

  put: async function (method: string, obj: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    const response: any = await api.put(method, obj, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json"
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck) {
        const createResult = await this.createToken();
        if (createResult) {
          return this.post(method, obj);
        }
      }
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },

  delete: async function (method: string, params?: any): Promise<ApiResponseType> {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    const response: any = await api.delete(method, {
      params: params,
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      const isTokenCheck = await this.checkToken();
      if (!isTokenCheck && method != "/token/checkToken") {
        const createResult = await this.createToken();
        if (createResult) {
          return this.get(method, params);
        }
      }
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },

  postFormData: async function (method: any, params: any) {
    const authToken = localStorage.getItem(AUTH_TOKEN);

    try {
      const response: any = await api.post(method, params, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.ok) {
        return apiHelper.apiSuccess({ result: response });
      } else {
        const isTokenCheck = await this.checkToken();
        if (!isTokenCheck) {
          const createResult = await this.createToken();
          if (createResult) {
            return this.post(method, params);
          }
        }
        return apiHelper.apiError({ errorMsg: response.data });
      }
    } catch (error) {
      return apiHelper.apiError({ errorMsg: error });
    }
  },

  createToken: async function () {
    const platform = appHelpers.getPlatform();
    if (platform == "web") return false;

    const client_id = process.env.REACT_APP_CLIENT_ID;
    const client_secret = process.env.REACT_APP_CLIENT_SECRET;

    const params = {
      ClientId: client_id,
      ClientSecret: client_secret,
      TaxNumber: appHelpers.getTaxNumber(),
      LicenceKey: appHelpers.getLicenceKey()
    };

    let retrunVal = false;

    try {
      const tokenresult = await axios.post(baseUrl + `/token`, params);

      if (tokenresult.data.isSuccess) {
        const { access_token, is_demo } = tokenresult.data.data;
        localStorage.setItem(AUTH_TOKEN, access_token);
        localStorage.setItem(IS_DEMO, is_demo);
        return true;
      } else {
        localStorage.setItem(IS_DEMO, "false");

        const data = tokenresult.data.data;
        if (data?.firmnotavailable) {
          const firmInfo = appHelpers.getForCreateFirm();
          const firmResult = await axios.post(baseUrl + `/token/createFirmIfPackage`, firmInfo);
          if (firmResult.data?.isSuccess) {
            const { access_token, is_demo } = firmResult.data;
            localStorage.setItem(AUTH_TOKEN, access_token);
            localStorage.setItem(IS_DEMO, is_demo);
            window.location.reload();
            retrunVal = true;
          }
        }
      }
    } catch { }

    return retrunVal;
  },

  checkToken: async function (passClear?: boolean) {
    const authToken = localStorage.getItem(AUTH_TOKEN);
    const url = baseUrl + "/token/checkToken";

    try {
      await axios.get(url, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      return true;
    } catch {
      const isLogoApp = isLogoAppProject();

      if (!isLogoApp && passClear !== true) {
        const currentUrl = window.location.href;
        const index = publicRoutes.findIndex(w =>
          currentUrl.indexOf(w.path || "") !== -1
        );

        if (index === -1) {
          this.clearLocalStorage();
          window.location.reload();
        }
      }

      return false;
    }
  },

  clearLocalStorage() {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i) || "";
      if (key !== FIRM_PATH) {
        localStorage.removeItem(key);
      }
    }
  },

  postUrl: async function (url: string, obj: any) {
    return axios
      .post(url, obj, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8"
        },
      })
      .then((res) => apiHelper.apiSuccess({ result: res }))
      .catch((err) =>
        apiHelper.apiError({ errorMsg: err })
      );
  },

  extractErrorMessage(error: any) {
    if (error.response?.data?.length > 0) {
      const serverMessage = error.response.data;
      return serverMessage.indexOf("Login Required") !== -1;
    }
    return false;
  }
};

export default commonNetwork;